import { configureStore } from '@reduxjs/toolkit';

import BLModalSlice from './BLModalSlice';
import { baseApi } from './api/baseApi';
import { setInvalidationStore } from './api/tableCacheInvalidation';
import userReducer from './authenticatedUserSlice';
import documentInfosReducer from './documentInfosSlice';
import notifReducer from './notifSlice';
import optionsSlice from './optionsSlice';

export const store = configureStore({
	reducer: {
		user: userReducer,
		documentInfos: documentInfosReducer,
		options: optionsSlice,
		pdfModel: BLModalSlice,
		notif: notifReducer,
		[baseApi.reducerPath]: baseApi.reducer,
	},
	middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
	devTools: process.env.NODE_ENV !== 'production',
});

setInvalidationStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
